// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"167":"detail","177":"home"}[chunkId] + "." + {"167":"13f1465d","177":"5c56ea81"}[chunkId] + ".css";
};